import { createFromToArray } from 'ml-spectra-processing';
import { parseSubHeader, setXYAxis } from "./shared.js";
/**
 * Reads a file's data block (old SPC format)
 * @param buffer - spc buffer.
 * @param fileHeader - header.
 * @returns Array containing the spectra.
 */
export function oldDataBlock(buffer, fileHeader) {
    // either Y or YY fall on the for loop
    const spectra = [];
    // old format uses always equidistant arrays
    const x = createFromToArray({
        from: fileHeader.startingX,
        to: fileHeader.endingX,
        length: fileHeader.numberPoints,
    });
    for (let i = 0; buffer.offset + fileHeader.numberPoints < buffer.length; i++) {
        const subFileHeader = parseSubHeader(buffer);
        const y = getOldY(new Float64Array(x.length), subFileHeader, fileHeader, buffer);
        const variables = setXYAxis(x, y, fileHeader);
        spectra.push({ meta: subFileHeader, variables });
    }
    return spectra;
}
/**
 * Reads Y values from the buffer for old format SPC files.
 * @param y - output Y array to fill.
 * @param subHeader - subfile header.
 * @param fileHeader - main file header.
 * @param buffer - SPC buffer.
 * @returns the filled Y array.
 */
export function getOldY(y, subHeader, fileHeader, buffer) {
    const { fileVersion, exponentY, parameters: { y16BitPrecision }, } = fileHeader;
    if (subHeader.exponentY === 0) {
        subHeader.exponentY = exponentY;
    }
    const yFactor = 2 ** (subHeader.exponentY - (y16BitPrecision ? 16 : 32));
    if (y16BitPrecision) {
        for (let j = 0; j < y.length; j++) {
            y[j] = buffer.readInt16() * yFactor;
        }
    }
    else {
        for (let j = 0; j < y.length; j++) {
            if (fileVersion === 0x4d) {
                y[j] =
                    ((buffer.readUint8() << 16) +
                        (buffer.readInt8() << 24) +
                        (buffer.readUint8() << 0) +
                        (buffer.readUint8() << 8)) *
                        yFactor;
            }
        }
    }
    return y;
}
//# sourceMappingURL=oldDataBlock.js.map